import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalComponent } from '@tecalisdev/infinity';
import { TranslatePipe } from '@ngx-translate/core';
import { PwcsInlineSvgComponent } from 'src/app/shared/components/pwcs-inline-svg/pwcs-inline-svg.component';

@Component({
	selector: 'app-modal-nie-soporte-help',
	imports: [ModalComponent, TranslatePipe, PwcsInlineSvgComponent],
	templateUrl: './modal-nie-soporte-help.component.html',
	styleUrl: './modal-nie-soporte-help.component.scss',
})
export class ModalNieSoporteHelpComponent {
	@Input() isVisible: boolean = false;
	@Input() url: string;
	@Output() isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	public closeModal(): void {
		this.isVisible = false;
		this.isVisibleChange.emit(false);
	}
}
